import React from "react";
import {
  createStyles,
  makeStyles,
  Menu,
  MenuItem,
  Paper,
} from "@material-ui/core";
import { ContentDetailTable } from "../../../components";
import { DocumentItemType } from "../../../types";

/** スタイル定義 */
const useStyles = makeStyles(() =>
  createStyles({
    contents: {
      // 表示オプションペインなしの高さ
      height: "calc(100vh - 155px)",
      // 表示オプションペインありの高さ
      // height: "calc(100vh - 203px)",
      marginTop: 5,
    },
    contextMenuItem: {
      fontSize: "0.875rem",
    },
  })
);

interface Props {
  items: DocumentItemType[];
  itemIndex: null | number;
  contextMenuData: {
    mouseX: null | number;
    mouseY: null | number;
  };
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
  handleClose: (event: React.MouseEvent<HTMLElement>) => void;
  handleOpenPreviewDialog: (event: React.MouseEvent<HTMLElement>) => void;
  // [HP稼働]: electronからの修正(不要処理削除)
  // handleOpenPath: (event: React.MouseEvent<HTMLElement>) => void;
  // handleShowItemInFolder: (event: React.MouseEvent<HTMLElement>) => void;
  // handleSTSearch: (event: React.MouseEvent<HTMLElement>) => void;
  handleOpenDetailFileInfoDialog: (
    event: React.MouseEvent<HTMLElement>
  ) => void;
}

/** 仮想フォルダーコンテンツ（詳細）コンポーネント */
export function VirtualFolderContentDetails(props: Props) {
  const classes = useStyles();

  const { items } = props;
  // [HP稼働]: electronからの修正(不要処理削除)
  // const { itemIndex } = props;

  //------------------------------
  // コンテキストメニュー
  // [State]
  const { contextMenuData } = props;

  // [Handler]
  const { handleClick } = props;
  const { handleClose } = props;
  const { handleOpenPreviewDialog } = props;
  // [HP稼働]: electronからの修正(不要処理削除)
  // const { handleOpenPath } = props;
  // const { handleShowItemInFolder } = props;
  // const { handleSTSearch } = props;
  const { handleOpenDetailFileInfoDialog } = props;

  // コンテキストメニュー定義
  const contextMenu = (
    <Menu
      keepMounted
      open={contextMenuData.mouseY !== null}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenuData.mouseY !== null && contextMenuData.mouseX !== null
          ? {
              top: contextMenuData.mouseY,
              left: contextMenuData.mouseX,
            }
          : undefined
      }
    >
      <MenuItem
        className={classes.contextMenuItem}
        onClick={handleOpenPreviewDialog}
      >
        プレビュー
      </MenuItem>
      {/* [HP稼働]: electronからの修正(不要処理削除) */}
      {/* <MenuItem className={classes.contextMenuItem} onClick={handleOpenPath}>
        アプリで開く
      </MenuItem>
      {(itemIndex === null ||
        (items.length > 0 && items[itemIndex].source_type === "NAS")) && (
        <MenuItem
          className={classes.contextMenuItem}
          onClick={handleShowItemInFolder}
        >
          ファイルの場所を開く
        </MenuItem>
      )}
      <MenuItem className={classes.contextMenuItem} onClick={handleSTSearch}>
        類似検索
      </MenuItem> */}
      <MenuItem
        className={classes.contextMenuItem}
        onClick={handleOpenDetailFileInfoDialog}
      >
        詳細情報
      </MenuItem>
    </Menu>
  );

  //--------------------
  // コンポーネント
  return (
    <Paper variant="outlined" className={classes.contents}>
      <ContentDetailTable
        rows={items}
        onClick={handleClick}
        contextMenu={contextMenu}
        containerType="virtualFolder"
      />
    </Paper>
  );
}
